import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getApiUrl } from '../../getApiUrl';

const apiUrl = getApiUrl();

const initialState = {
  loading: false,
  error: null,
  success: null,
  loggedIn:
    typeof window !== 'undefined' && !!localStorage.getItem('accessToken'),
  user:
    typeof window !== 'undefined'
      ? JSON.parse(localStorage.getItem('new_user') || 'null')
      : null,
};

export const newLogin = createAsyncThunk(
  'auth/login',
  async ({ username, password, mobilenumber }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/user/login`,
        { username, password, mobilenumber },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
      // if (response.data.status !== 'success') {
      //   return rejectWithValue(response.data?.msg || 'Login failed');
      // }

      const token = response.data.token;
      const user = {
        name: username,
        phoneNumber: mobilenumber,
      };

      localStorage.setItem('accessToken', token);
      localStorage.setItem('new_user', JSON.stringify(user));

      return {
        user,
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Login error');
    }
  }
);

const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    isLoggedin(state, action) {
      state.loggedIn = action.payload;
    },
    setStatus(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(newLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(newLogin.fulfilled, (state, action) => {
        const user = {
          name: action.meta.arg.username,        // was userName
          phoneNumber: action.meta.arg.mobilenumber, // was mobileNumber
        };

        const username = user.name?.toLowerCase() || '';

        if (username.includes('developer')) user.persona = 'developers';
        if (username.includes('supplier')) user.persona = 'suppliers';
        if (username.includes('startup')) user.persona = 'startups';
        if (username.includes('financier')) user.persona = 'financiers';

        localStorage.setItem('new_user', JSON.stringify(user));

        state.loggedIn = true;

        state.loading = false;
        state.error = null;
        state.success = action.payload; // keep this as you had
      })
      .addCase(newLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // error.response.data from rejectWithValue
        state.success = null;
      });
  }

});

export const { isLoggedin, setStatus } = loginSlice.actions;
export default loginSlice.reducer;
